import { createVehicleAccessories, updateVehicleAccessories } from 'api/vehicleAccessories';
import { PackagingTypes } from 'enums/types';
import { debounceVehicle } from 'utils/debounces';

import type { FormType } from '..';

export const vehicleAccessoryForm: FormType = {
  createFn: createVehicleAccessories,
  updateFn: updateVehicleAccessories,
  cancelText: 'Cancelar',
  submitText: 'Salvar Acessório',
  disableText: 'Desativar Acessório',
  enableText: 'Reativar Acessório',
  successText: 'Acessório salvo com sucesso!',
  fields: [
    [
      {
        name: 'serialNumber',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Número de Série',
          label: 'Número de Série',
        },
      }, {
        name: 'assetNumber',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Número de Patrimônio',
          label: 'Número de Patrimônio',
        },
      },
    ],
    [
      {
        name: 'calibrationDate',
        type: 'date',
        required: false,
        props: {
          placeholder: '01/01/2000',
          label: 'Data da Calibração',
        },
      },
      {
        name: 'calibrationDueDate',
        type: 'date',
        required: false,
        props: {
          placeholder: '01/01/2000',
          label: 'Validade da Calibração',
        },
      },
    ],
    [
      {
        name: 'vehicle',
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Veículo Vinculado',
          loadOptions: debounceVehicle,
        },
      },
    ],
    [
      {
        name: 'containerType',
        type: 'radio',
        required: false,
        props: {
          label: 'Tipo de Container',
          options: [
            ...Object.values(PackagingTypes).map((type) => ({ label: type, value: type })),
            { label: 'Não é um container', value: 'null' },
          ],
        },
      },
    ],
  ],
};
